export default __webpack_public_path__ + "static/media/Copy of Cyber Policy.328361bd.jpg";